import React from 'react';
import { NavLink } from 'react-router-dom';
import style from "./Footer.module.css";
import { FaTwitter, FaFacebookF, FaInstagram, FaYoutube, FaTwitch, FaTelegramPlane, FaTiktok, FaVk, FaPhoneAlt } from "react-icons/fa";
import pay1 from "../../assets/pay1.png"
import pay2 from "../../assets/pay2.png"
import { TiLocationOutline } from "react-icons/ti";


const Footer = () => {
  return (
    <div className={style.footer}>
      <div className={style.container}>
        <div className={style.row}>

          <div className={style.col}>
            <h4>Company</h4>
            <ul className="list-unstyled">
              <li><NavLink to="/Aboutus">About</NavLink></li>
              <li><NavLink to="/Contact">Contact</NavLink></li>
              <li><NavLink to="/TC">Terms and Conditions</NavLink></li>
              <li><NavLink to="/PrivacyPolicy">Privacy Policy</NavLink></li>
            </ul>
          </div>

          <div className={style.col}>
            <h4>Reviews</h4>
            <ul className="list-unstyled">
              <li><NavLink to="/News">News</NavLink></li>
              <li><NavLink to="/Testimonials">Testimonials</NavLink></li>
            </ul>
          </div>

          <div className={style.col}>
            <h4>Support</h4>
            <ul className="list-unstyled">
              <li><NavLink to="/CustomerService">Customer Service</NavLink></li>
              <li><NavLink to="/FAQs">FAQs</NavLink></li>
            </ul>
          </div>
          <div className={style.col}>
            <h4>Community</h4>
            <ul className="list-unstyled">
              <li><NavLink to="/Blog">News</NavLink></li>
              <li><NavLink to="/Twitch">Twitch Prime</NavLink></li>
            </ul>
          </div>
          <div className={style.col}>
            <h4>Payment Options</h4>
            <ul className="list-unstyled">
              <li><NavLink to="/CustomerService"><img className={style.pay__img} src={pay1} alt="" /></NavLink></li>
              <li><NavLink to="/FAQs"><img className={style.pay__img} src={pay2} alt="" /></NavLink></li>
            </ul>
          </div>
          <div className={style.col}>
            <h4>Contacts</h4>
            <ul className="list-unstyled">
              <li className={style.find}><FaPhoneAlt /> +998(90) 006-66-60</li>
              <li className={style.find}><TiLocationOutline /> Юнусабадский район, Ташкент, Узбекистан</li>
              <li className={style.find}><FaTelegramPlane />Telegram</li>
              <li className={style.find}><FaInstagram />Instagram</li>
            </ul>
          </div>

        </div>
        <hr />
        <div className={style.social__media}>
          <div className={style.social__media}><FaTwitter />
            <FaFacebookF /> <FaInstagram /><FaYoutube /><FaTwitch /><FaTelegramPlane /><FaTiktok /><FaVk />
          </div>
          <div></div>
        </div>
        <div className={style.final}>
          <p className={style.colsm}>
            &copy;{new Date().getFullYear()} PC Engine | All rights reserved |
            Terms Of Service | Privacy
          </p>
        </div>
      </div>
    </div>
  )
}

export default Footer